module.exports = __webpack_public_path__ + "f8303d484f23618ed951cb87f6094a84.svg";